export default {
  "story": "_story_1ffzfu",
  "dark-background": "_dark-background_1ffzfu"
};